import { Switch, Route, Redirect, useRouteMatch } from 'peach/router'

import Supercase from './Supercase'
import Supercases from './Supercases'
import CreateSupercase from './CreateSupercase'

const SupercasesRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <Supercases />
      </Route>

      <Route path={`${path}/create`}>
        <CreateSupercase />
      </Route>

      <Route path={`${path}/:supercaseId`}>
        <Supercase />
      </Route>

      <Redirect to={url} />
    </Switch>
  )
}

export default SupercasesRoutes
